import { logger } from '@/shared/common/utils/logger.util';
import {
  LAYOUT_SKELETON_VARIANT_STORAGE_KEY,
  PERSISTED_LAYOUT_SKELETON_VARIANTS,
} from '../constants/mainLayout.constant';
import type {
  LayoutContentSkeletonVariant,
  PersistedLayoutSkeletonVariant,
} from '../types/mainLayout.type';

function isPersistedVariant(
  value: string | null
): value is PersistedLayoutSkeletonVariant {
  return PERSISTED_LAYOUT_SKELETON_VARIANTS.some((variant) => variant === value);
}

/**
 * Forma de la home guardada en la recarga anterior. El storage puede estar bloqueado
 * (modo privado, política del navegador): en ese caso devuelve `null` y lo loguea.
 */
export function getStoredLayoutSkeletonVariant(): PersistedLayoutSkeletonVariant | null {
  try {
    const value = localStorage.getItem(LAYOUT_SKELETON_VARIANT_STORAGE_KEY);
    return isPersistedVariant(value) ? value : null;
  } catch (error) {
    logger.warn('[layoutSkeletonVariantStorage] No se pudo leer la forma del skeleton', {
      error,
    });
    return null;
  }
}

/**
 * Guarda solo `home`/`onboarding`: una ruta genérica no pisa la forma de la home, que es
 * la que el shell necesita en la próxima recarga.
 */
export function saveLayoutSkeletonVariant(variant: LayoutContentSkeletonVariant): void {
  if (!isPersistedVariant(variant)) return;

  try {
    localStorage.setItem(LAYOUT_SKELETON_VARIANT_STORAGE_KEY, variant);
  } catch (error) {
    logger.warn('[layoutSkeletonVariantStorage] No se pudo guardar la forma del skeleton', {
      error,
    });
  }
}
